import React from 'react';
import styles from './Container.module.css';

type t_props = React.HTMLProps<HTMLDivElement>;

const Container=(props: t_props)=><div {...props} className={`${styles.container} ${props.className??''}`} />
export default Container;
